import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-60265a92")

_pushScopeId("data-v-60265a92")
const _hoisted_1 = {
  key: 0,
  ref: "modal",
  tabindex: "0",
  class: "justify-center items-center flex bg-overlay fixed inset-0 z-50 overflow-hidden"
}
const _hoisted_2 = {
  class: "relative bg-white text-gray-lp-300 max-w-full flex-col flex rounded-lg",
  style: {"max-height":"85vh"}
}
const _hoisted_3 = { class: "flex flex-no-wrap h-full overflow-scroll" }
const _hoisted_4 = {
  style: {"width":"940px"},
  class: "relative p-4 space-y-4"
}
const _hoisted_5 = { class: "flex flex-row items-center justify-between border-b-2 sticky top-0 bg-white z-10 pb-2" }
const _hoisted_6 = { class: "text-20px" }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = { class: "w-1/3" }
const _hoisted_9 = {
  key: 0,
  class: "border border-gray-lp-1400 p-4 rounded-2xl space-y-2"
}
const _hoisted_10 = { class: "rounded-2xl border border-gray-lp-1400" }
const _hoisted_11 = { class: "bg-gray-lp-1000 rounded-2xl p-4 flex flex-row justify-between items-center" }
const _hoisted_12 = { class: "text-red-lp-100 text-xl font-semibold" }
const _hoisted_13 = { class: "text-red-lp-100 text-2xl font-bold flex flex-row items-center space-x-2" }
const _hoisted_14 = {
  key: 0,
  class: "max-h-40 overflow-auto w-full pl-8 pr-4"
}
const _hoisted_15 = { class: "w-full py-2 flex flex-row justify-between items-center text-base text-black-lp-300" }
const _hoisted_16 = { class: "flex flex-row justify-between items-baseline w-full gap-10" }
const _hoisted_17 = { class: "w-1/2" }
const _hoisted_18 = { class: "flex flex-col gap-2 w-1/2" }
const _hoisted_19 = { class: "flex flex-col justify-end items-end" }
const _hoisted_20 = {
  key: 1,
  class: "border border-gray-lp-1400 p-4 rounded-2xl space-y-2"
}
const _hoisted_21 = { class: "bg-gray-lp-1000 p-4 rounded-2xl flex flex-row justify-between items-center" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = { class: "text-red-lp-100 text-xl font-semibold" }
const _hoisted_24 = { class: "flex flex-row items-center space-x-8 text-base text-gray-lp-800 w-full" }
const _hoisted_25 = { class: "flex flex-row items-center space-x-1" }
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" DEX ")
const _hoisted_27 = { class: "font-bold" }
const _hoisted_28 = { class: "font-semibold" }
const _hoisted_29 = { class: "flex flex-row items-center space-x-1" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" CODREJ ")
const _hoisted_31 = { class: "font-bold" }
const _hoisted_32 = { class: "font-semibold" }
const _hoisted_33 = { class: "text-red-lp-100 text-2xl font-bold" }
const _hoisted_34 = { class: "text-base font-semibold" }
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = { class: "input-scan w-full" }
const _hoisted_37 = { class: "overflow-auto" }
const _hoisted_38 = { class: "sticky flex flex-row items-center justify-between space-x-4 p-4" }
const _hoisted_39 = { class: "flex flex-row items-center space-x-2 pb-2" }
const _hoisted_40 = {
  key: 0,
  class: "px-6 py-2 rounded-lg justify-start items-center gap-4 inline-flex",
  style: {"background":"linear-gradient(135deg, #FFF9F7 0%, #F7C9D2 100%)","border":"0.84px #DC8F92 solid"}
}
const _hoisted_41 = { class: "text-center text-red-lp-100 text-base font-bold" }
const _hoisted_42 = {
  class: "px-6 py-2 rounded-lg justify-start items-center gap-4 inline-flex",
  style: {"background":"linear-gradient(135deg, #FFF9F7 0%, #F7C9D2 100%)","border":"0.84px #DC8F92 solid"}
}
const _hoisted_43 = {
  "data-testid": "cod-deposit-display-total",
  class: "text-center text-red-lp-100 text-base font-bold"
}
const _hoisted_44 = { class: "flex flex-row items-center space-x-2" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_SectionUploadPhotoCodReconcile = _resolveComponent("SectionUploadPhotoCodReconcile")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_HistoryTable = _resolveComponent("HistoryTable")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ImagePreviewReconcile = _resolveComponent("ImagePreviewReconcile")!
  const _component_SttDetailModal = _resolveComponent("SttDetailModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.modelValue)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("div", _hoisted_5, [
                  _createVNode("div", _hoisted_6, [
                    _createTextVNode(_toDisplayString(_ctx.$t("codReconcile.dailyDeposit.titleSetorHarian")) + " ", 1),
                    _createVNode("span", _hoisted_7, " - " + _toDisplayString(_ctx.detailDataCourier.courierName), 1)
                  ]),
                  _createVNode("div", _hoisted_8, [
                    _createVNode(_component_DatePicker, {
                      modelValue: _ctx.form.date,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.date = $event)),
                      "max-date": new Date(),
                      class: "w-full mt-2",
                      disabled: ""
                    }, null, 8, ["modelValue", "max-date"])
                  ])
                ]),
                (_ctx.courierSummary.codAmountDeposit.pending)
                  ? (_openBlock(), _createBlock("div", _hoisted_9, [
                      _createVNode("div", _hoisted_10, [
                        _createVNode("div", _hoisted_11, [
                          _createVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("codReconcile.dailyDeposit.jumlahUangDisetor")), 1),
                          _createVNode("div", _hoisted_13, [
                            _createVNode("div", null, _toDisplayString(_ctx.formatPriceRp(_ctx.courierSummary.codAmountDeposit?.pending)), 1),
                            _createVNode(_component_Icons, {
                              name: [_ctx.expandSttPending ? 'chevron-up' : 'chevron-down'],
                              class: ["w-5", [
                      _ctx.courierSummary.codAmountDeposit?.pending
                        ? 'cursor-pointer'
                        : '',
                    ]],
                              onClick: _ctx.onExpandSttPending
                            }, null, 8, ["name", "class", "onClick"])
                          ])
                        ]),
                        (_ctx.expandSttPending)
                          ? (_openBlock(), _createBlock("div", _hoisted_14, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailCourierSuccess, (item) => {
                                return (_openBlock(), _createBlock("ul", {
                                  class: "list-disc",
                                  key: item.sttNo
                                }, [
                                  _createVNode("li", null, [
                                    _createVNode("div", _hoisted_15, [
                                      _createVNode("div", null, _toDisplayString(item.sttNo), 1),
                                      _createVNode("div", null, _toDisplayString(_ctx.formatPriceRp(item.sttCodAmount)), 1)
                                    ])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_DataWrapper, {
                        label: _ctx.$t('codReconcile.dailyDeposit.jumlahUangDisetor'),
                        class: "w-full",
                        "font-size": 14
                      }, {
                        default: _withId(() => [
                          _createVNode(_component_LpInput, {
                            modelValue: _ctx.form.deposit,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.deposit = $event)),
                            placeholder: "e.g 100.000",
                            prefix: _ctx.prefixCurrency,
                            format: _ctx.formatMoney,
                            disabled: !_ctx.courierSummary.codAmountDeposit?.pending,
                            onChange: _cache[3] || (_cache[3] = (value) => _ctx.validationInput(value, 'deposit')),
                            class: "py-3",
                            error: _ctx.isErrorDeposit,
                            errorCaption: _ctx.$t('codReconcile.dailyDeposit.errorAmount'),
                            isErrorIconInput: false,
                            "data-testid": "cod-deposit-input-amount"
                          }, null, 8, ["modelValue", "prefix", "format", "disabled", "error", "errorCaption"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode("div", _hoisted_16, [
                        _createVNode("div", _hoisted_17, [
                          _createVNode(_component_SectionUploadPhotoCodReconcile, {
                            key: JSON.stringify(_ctx.courierNotePhotosUrl),
                            modelValue: _ctx.courierNotePhotosUrl,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.courierNotePhotosUrl = $event)),
                            onOnSuccessUploadImage: _ctx.onSubmitCourierNotesPhoto,
                            onOnSuccessDeleteImage: _ctx.onSubmitCourierNotesPhoto,
                            onPreview: _cache[5] || (_cache[5] = 
                    (index) => {
                      _ctx.previewCourierNotesPhoto = true;
                      _ctx.previewCourierNotesPhotoIndex = index;
                    }
                  )
                          }, null, 8, ["modelValue", "onOnSuccessUploadImage", "onOnSuccessDeleteImage"])
                        ]),
                        _createVNode("div", _hoisted_18, [
                          _createVNode(_component_DataWrapper, {
                            label: _ctx.$t('codReconcile.dailyDeposit.catatan'),
                            class: "w-full",
                            "font-size": 14
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_LpInput, {
                                modelValue: _ctx.courierNotes,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.courierNotes = $event)),
                                placeholder: _ctx.$t('codReconcile.dailyDeposit.catatan'),
                                class: "py-3"
                              }, null, 8, ["modelValue", "placeholder"])
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode("div", _hoisted_19, [
                            _createVNode(_component_LpButton, {
                              title: _ctx.$t('codReconcile.dailyDeposit.simpan'),
                              customClass: "px-4 py-2",
                              iconLeft: "ics_f_save",
                              textColor: "white",
                              compact: "",
                              onClick: _ctx.onSubmitCourierNotes
                            }, null, 8, ["title", "onClick"])
                          ])
                        ])
                      ]),
                      (_ctx.courierHistory.length)
                        ? (_openBlock(), _createBlock(_component_HistoryTable, {
                            key: 0,
                            histories: _ctx.courierHistory,
                            onShowModal: _ctx.showModalStt,
                            onShowModalPreviewImage: _ctx.showModalPreviewImage
                          }, null, 8, ["histories", "onShowModal", "onShowModalPreviewImage"]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.courierSummaryCount.totalStt)
                  ? (_openBlock(), _createBlock("div", _hoisted_20, [
                      _createVNode("div", _hoisted_21, [
                        _createVNode("div", _hoisted_22, [
                          _createVNode("div", _hoisted_23, _toDisplayString(_ctx.$t("codReconcile.summary.totalSttToDeposit")), 1),
                          _createVNode("div", _hoisted_24, [
                            _createVNode("div", _hoisted_25, [
                              _createVNode(_component_Icons, {
                                name: "dex",
                                class: "w-5"
                              }),
                              _createVNode("div", null, [
                                _hoisted_26,
                                _createVNode("span", _hoisted_27, _toDisplayString(_ctx.formatPriceWithoutCurrency(
                            _ctx.courierSummaryCount.totalSttDex
                          )) + " STT ", 1),
                                _createVNode("span", _hoisted_28, " (" + _toDisplayString(_ctx.formatPriceWithoutCurrency(
                            _ctx.courierSummaryCount.totalSttDexPieces
                          )) + " koli) ", 1)
                              ])
                            ]),
                            _createVNode("div", _hoisted_29, [
                              _createVNode(_component_Icons, {
                                name: "codrej",
                                class: "w-5"
                              }),
                              _createVNode("div", null, [
                                _hoisted_30,
                                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.formatPriceWithoutCurrency(
                            _ctx.courierSummaryCount.totalSttCodrej
                          )) + " STT ", 1),
                                _createVNode("span", _hoisted_32, " (" + _toDisplayString(_ctx.formatPriceWithoutCurrency(
                            _ctx.courierSummaryCount.totalSttCodrejPieces
                          )) + " koli) ", 1)
                              ])
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_33, [
                          _createTextVNode(_toDisplayString(_ctx.formatPriceWithoutCurrency(_ctx.courierSummaryCount.totalStt)) + " STT ", 1),
                          _createVNode("span", _hoisted_34, " (" + _toDisplayString(_ctx.formatPriceWithoutCurrency(
                      _ctx.courierSummaryCount.totalSttPieces
                    )) + " koli) ", 1)
                        ])
                      ]),
                      _createVNode("div", _hoisted_35, [
                        _createVNode("div", _hoisted_36, [
                          _createVNode(_component_lp_input, {
                            id: "cod-reconcile-scan",
                            ref: "inputStt",
                            modelValue: _ctx.sttNumber,
                            sizeInput: "24px",
                            labelStacked: 
                    _ctx.$t('Contoh : 99LP1234567890123/88-22-12345678')
                  ,
                            placeholder: _ctx.$t('Masukan no. STT atau scan barcode/QR code'),
                            onEnter: _ctx.onScanSttNumber,
                            onEvent: _ctx.onFocusStt
                          }, null, 8, ["modelValue", "labelStacked", "placeholder", "onEnter", "onEvent"])
                        ]),
                        _createVNode("div", _hoisted_37, [
                          _createVNode(_component_TableV2, {
                            ref: "detailCourierTable",
                            columns: _ctx.columns,
                            data: _ctx.isEmptyList ? [] : _ctx.detailCourier,
                            isEmpty: _ctx.isEmptyList,
                            onRequest: _ctx.getDetailCourierFailed,
                            "onUpdate:checkedData": _ctx.selectData,
                            hidePagination: "",
                            iconEmpty: _ctx.emptyIcon,
                            emptyHeaderMessage: _ctx.emptyTitle,
                            emptyMessage: _ctx.emptyMessage,
                            pinnedSubstractHeight: "415px",
                            isCheckBox: "",
                            borderTop: false,
                            borderBottom: false,
                            iconColor: "green-lp-100",
                            isNoPaddingBottom: "",
                            isDownloadCheckBox: false
                          }, null, 8, ["columns", "data", "isEmpty", "onRequest", "onUpdate:checkedData", "iconEmpty", "emptyHeaderMessage", "emptyMessage"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createVNode("div", _hoisted_38, [
              _createVNode("div", _hoisted_39, [
                (_ctx.dataSelected.length)
                  ? (_openBlock(), _createBlock("div", _hoisted_40, [
                      _createVNode("div", _hoisted_41, _toDisplayString(_ctx.formatPriceWithoutCurrency(_ctx.dataSelected.length)) + " STT dipilih ", 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("div", _hoisted_42, [
                  _createVNode("div", _hoisted_43, _toDisplayString(_ctx.formatPriceRp(_ctx.depositValue)) + " yang disetor ", 1)
                ])
              ]),
              _createVNode("div", _hoisted_44, [
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('codReconcile.dailyDeposit.batal'),
                  outline: "",
                  textColor: "red-lp-100",
                  onClick: _cache[7] || (_cache[7] = () => _ctx.closeDialog(false))
                }, null, 8, ["title"]),
                _createVNode(_component_LpButton, {
                  title: _ctx.$t('codReconcile.dailyDeposit.setor'),
                  textColor: "white",
                  disabled: _ctx.isDisabled,
                  onClick: _ctx.postCourierDailyDeposit
                }, null, 8, ["title", "disabled", "onClick"])
              ])
            ])
          ]),
          (_ctx.previewCourierNotesPhoto)
            ? (_openBlock(), _createBlock(_component_ImagePreviewReconcile, {
                key: 0,
                onClose: _cache[8] || (_cache[8] = () => (_ctx.previewCourierNotesPhoto = false)),
                data: _ctx.courierNotePhotosUrl.filter((url) => url),
                initialIndex: _ctx.previewCourierNotesPhotoIndex
              }, null, 8, ["data", "initialIndex"]))
            : _createCommentVNode("", true),
          (_ctx.isShowModalPreviewImage)
            ? (_openBlock(), _createBlock(_component_ImagePreviewReconcile, {
                key: 1,
                onClose: _cache[9] || (_cache[9] = () => (_ctx.isShowModalPreviewImage = false)),
                data: _ctx.previewImageDetalStt.filter((url) => url),
                initialIndex: 0
              }, null, 8, ["data"]))
            : _createCommentVNode("", true)
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_SttDetailModal, {
      modelValue: _ctx.showModalDetailStt,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.showModalDetailStt = $event)),
      sttList: _ctx.sttList,
      onClose: _ctx.closeDetailStt
    }, null, 8, ["modelValue", "sttList", "onClose"])
  ], 64))
})